import { Routes, Route } from 'react-router-dom';
import { AppShell, Container, Group, Header, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconBell, IconBolt, IconBuilding, IconHome, IconUsers } from '@tabler/icons';
import { NavLinkItem, ProtectedRoute, UserMenu } from './components';
import { LoginContainer } from './containers/login-container';
import { AccountsContainer } from './containers/accounts-container';
import { AccountContainer } from './containers/account-container';
import { UsersContainer } from './containers/users-container';
import { UserContainer } from './containers/user-container';
import { NotificationSettingsContainer } from './containers/notification-settings-container';

function HomePage() {
  return (
    <Stack>
      <Title order={2}>Welcome, Admin</Title>
      <Text>This is the Bagel Admin app. Use the nav to get around.</Text>
    </Stack>
  );
}

function ProtectedShell() {
  return (
    <AppShell
      padding="md"
      header={
        <Header height={56} px="md">
          <Group position="apart" sx={{ height: '100%' }} noWrap>
            <Group spacing="xl" noWrap>
              <Group spacing="xs" noWrap>
                <ThemeIcon size="md" radius="md" variant="filled" color="bagel">
                  <IconBolt size={16} stroke={2.5} />
                </ThemeIcon>
                <Title order={4} sx={{ letterSpacing: -0.2 }}>
                  Bagel Admin
                </Title>
              </Group>
              <Group spacing={4} noWrap>
                <NavLinkItem to="/" end icon={<IconHome size={16} />}>
                  Home
                </NavLinkItem>
                <NavLinkItem to="/accounts" icon={<IconBuilding size={16} />}>
                  Accounts
                </NavLinkItem>
                <NavLinkItem to="/users" icon={<IconUsers size={16} />}>
                  Users
                </NavLinkItem>
                <NavLinkItem to="/notification-settings" icon={<IconBell size={16} />}>
                  Notifications
                </NavLinkItem>
              </Group>
            </Group>
            <UserMenu />
          </Group>
        </Header>
      }
    >
      <Container fluid px="xl">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/accounts" element={<AccountsContainer />} />
          <Route path="/account/:accountId" element={<AccountContainer />} />
          <Route path="/account/:accountId/:tab" element={<AccountContainer />} />
          <Route
            path="/account/:accountId/integration/:installationId"
            element={<AccountContainer />}
          />
          <Route
            path="/account/:accountId/integration/:installationId/:detailTab"
            element={<AccountContainer />}
          />
          <Route path="/account/:accountId/job/:jobId" element={<AccountContainer />} />
          <Route path="/users" element={<UsersContainer />} />
          <Route path="/user/:userId" element={<UserContainer />} />
          <Route path="/notification-settings" element={<NotificationSettingsContainer />} />
        </Routes>
      </Container>
    </AppShell>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginContainer />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <ProtectedShell />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
